const initVal = null;

const LookUpDataReducer = (state = initVal, action) => {
  switch (action.type) {
    case "SETLOOKUPDATA":
      return action.payload;
    case "DESTROYLOOKUPDATA":
      return initVal;
    case "UPDATELOOKUPDATA":
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export default LookUpDataReducer;
